<app-tab-toolbar [tabId]="'salary2'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges && !isStandardsCarriedForward"
  [showOtherMeasurement]="true" [otherMeasurement]="otherMeasurement"
  [showKeywordsToggle]="true" [keywordsVisible]="showKeywords"
  (keywordsVisibleChange)="showKeywords = $event"
  (yearChange)="onYearChange($event)" (otherMeasurementChange)="onOtherMeasurementChange($event)"
  (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>warning</mat-icon>
      <span>There is no data for the selected year</span>
    </div>
  }
</app-tab-toolbar>

<div class="salary2-content" [formGroup]="form" [appReadOnlyTab]="'salary2'">

  @if (isStandardsCarriedForward) {
    <div class="year-warning">
      <mat-icon>info</mat-icon>
      <span>Compensation summary standards carried forward from a previous year.</span>
    </div>
  }

  <!-- Bottom sections: Non-Executive Fees + Compensation Consultant -->
  <div class="bottom-sections">

    <!-- Non Executive Fees -->
    <div class="bottom-panel">
      <h3 class="section-title">Non Executive Fees</h3>
      <div class="fees-grid">
        <div class="fees-header">Occupation</div>
        <div class="fees-header">Fees</div>
        @for (row of nonExecutiveFeeRows; track row.field) {
          <div class="fees-label">{{ row.label }}</div>
          <div class="fees-cell">
            <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.field" class="ht-input">
            @if (otherMeasurement && isDifferent(form.get(row.field)?.value, getOtherField(row.field))) {<span class="ht-other">{{ formatOther(getOtherField(row.field)) }}</span>}
          </div>
        }
      </div>

      @if (showKeywords) {
        <div class="keywords-inline" formGroupName="keywords">
          <div class="keywords-header">
            <span>Keywords</span>
          </div>
          <div class="keywords-fields">
            <div class="keywords-column">
              <app-keyword-input name="nonExecutiveFeesOne" label="Non Executive Fees 1" />
            </div>
            <div class="keywords-column">
              <app-keyword-input name="nonExecutiveFeesTwo" label="Non Executive Fees 2" />
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Right side: Ownership Guidelines + Compensation Consultant + CEO Pay Ratio -->
    <div class="bottom-panel">
      <h3 class="section-title">Ownership Guidelines</h3>
      <div class="compensation-summary-grid">
        <!-- Header -->
        <div class="cs-header cs-header-label"></div>
        <div class="cs-header">Multiplier</div>
        <div class="cs-header">Standard</div>
        <div class="cs-header">Amount</div>

        <!-- Rows -->
        @for (row of compensationSummaryRows; track row.prefix) {
          <div class="cs-label">{{ row.label }}</div>
          <div class="cs-cell">
            <select [formControlName]="row.prefix + 'MultiplierId'" class="ht-input">
              <option [ngValue]="null"></option>
              @for (m of multipliers; track m.id) {
                <option [ngValue]="m.id">{{ m.value }}</option>
              }
            </select>
            @if (otherMeasurement && isDifferent(form.get(row.prefix + 'MultiplierId')?.value, getOtherStringField(row.prefix + 'MultiplierId'))) {<span class="ht-other ht-other-left">{{ getMultiplierDisplay(getOtherStringField(row.prefix + 'MultiplierId')) }}</span>}
          </div>
          <div class="cs-cell">
            <select [formControlName]="row.prefix + 'StandardId'" class="ht-input">
              <option [ngValue]="null"></option>
              @for (s of standards; track s.id) {
                <option [ngValue]="s.id">{{ s.name }}</option>
              }
            </select>
            @if (otherMeasurement && isDifferent(form.get(row.prefix + 'StandardId')?.value, getOtherStringField(row.prefix + 'StandardId'))) {<span class="ht-other ht-other-left">{{ getOtherStringField(row.prefix + 'StandardName') }}</span>}
          </div>
          <div class="cs-cell">
            <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.prefix + 'Amount'" class="ht-input">
            @if (otherMeasurement && isDifferent(form.get(row.prefix + 'Amount')?.value, getOtherField(row.prefix + 'Amount'))) {<span class="ht-other">{{ formatOther(getOtherField(row.prefix + 'Amount')) }}</span>}
          </div>
        }
      </div>

      @if (showKeywords) {
        <div class="keywords-inline" formGroupName="keywords">
          <div class="keywords-header">
            <span>Keywords</span>
          </div>
          <div class="keywords-fields">
            <div class="keywords-column">
              <app-keyword-input name="ownershipGuidelinesOne" label="Ownership Guidelines 1" />
            </div>
            <div class="keywords-column">
              <app-keyword-input name="ownershipGuidelinesTwo" label="Ownership Guidelines 2" />
            </div>
          </div>
        </div>
      }

      <h3 class="section-title" style="margin-top: 12px">Compensation Consultant</h3>
      <div class="consultant-grid">
        <div class="consultant-header consultant-header-label"></div>
        <div class="consultant-header">Firm 1</div>
        <div class="consultant-header">Firm 2</div>

        <div class="consultant-label">Consultant Firm</div>
        <div class="consultant-cell">
          <div class="autocomplete-wrapper">
            <input type="text" class="ht-input ht-input-text"
                   [formControl]="consultantFirm1SearchControl"
                   [matAutocomplete]="autoConsultantFirm1"
                   placeholder="Type to search...">
            @if (!isReadOnly() && consultantFirm1SearchControl.value) {
              <button class="autocomplete-clear" (click)="clearConsultantFirm(1)" type="button" tabindex="-1">
                <mat-icon>close</mat-icon>
              </button>
            }
            <mat-autocomplete #autoConsultantFirm1="matAutocomplete"
                              (optionSelected)="onConsultantFirmSelected(1, $event.option.value)">
              @for (firm of filteredConsultantFirms1; track firm.id) {
                <mat-option [value]="firm">{{ firm.name }}</mat-option>
              }
              @if (filteredConsultantFirms1.length === 0 && consultantFirm1SearchControl.value && consultantFirm1SearchControl.value.length >= 2) {
                <mat-option disabled>No results found</mat-option>
              }
            </mat-autocomplete>
          </div>
          @if (otherMeasurement && isDifferent(form.get('consultantFirm1Id')?.value, getOtherStringField('consultantFirm1Id'))) {<span class="ht-other ht-other-left">{{ getOtherStringField('consultantFirm1Name') }}</span>}
        </div>
        <div class="consultant-cell">
          <div class="autocomplete-wrapper">
            <input type="text" class="ht-input ht-input-text"
                   [formControl]="consultantFirm2SearchControl"
                   [matAutocomplete]="autoConsultantFirm2"
                   placeholder="Type to search...">
            @if (!isReadOnly() && consultantFirm2SearchControl.value) {
              <button class="autocomplete-clear" (click)="clearConsultantFirm(2)" type="button" tabindex="-1">
                <mat-icon>close</mat-icon>
              </button>
            }
            <mat-autocomplete #autoConsultantFirm2="matAutocomplete"
                              (optionSelected)="onConsultantFirmSelected(2, $event.option.value)">
              @for (firm of filteredConsultantFirms2; track firm.id) {
                <mat-option [value]="firm">{{ firm.name }}</mat-option>
              }
              @if (filteredConsultantFirms2.length === 0 && consultantFirm2SearchControl.value && consultantFirm2SearchControl.value.length >= 2) {
                <mat-option disabled>No results found</mat-option>
              }
            </mat-autocomplete>
          </div>
          @if (otherMeasurement && isDifferent(form.get('consultantFirm2Id')?.value, getOtherStringField('consultantFirm2Id'))) {<span class="ht-other ht-other-left">{{ getOtherStringField('consultantFirm2Name') }}</span>}
        </div>

        <div class="consultant-label">Consultant Name</div>
        <div class="consultant-cell">
          <input type="text" formControlName="consultantName1" class="ht-input ht-input-text">
          @if (otherMeasurement && isDifferent(form.get('consultantName1')?.value, getOtherStringField('consultantName1'))) {<span class="ht-other ht-other-left">{{ getOtherStringField('consultantName1') }}</span>}
        </div>
        <div class="consultant-cell">
          <input type="text" formControlName="consultantName2" class="ht-input ht-input-text">
          @if (otherMeasurement && isDifferent(form.get('consultantName2')?.value, getOtherStringField('consultantName2'))) {<span class="ht-other ht-other-left">{{ getOtherStringField('consultantName2') }}</span>}
        </div>

        <div class="consultant-label">Compensation Fees</div>
        <div class="consultant-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="compensationFees1" class="ht-input">
          @if (otherMeasurement && isDifferent(form.get('compensationFees1')?.value, getOtherField('compensationFees1'))) {<span class="ht-other">{{ formatOther(getOtherField('compensationFees1')) }}</span>}
        </div>
        <div class="consultant-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="compensationFees2" class="ht-input">
          @if (otherMeasurement && isDifferent(form.get('compensationFees2')?.value, getOtherField('compensationFees2'))) {<span class="ht-other">{{ formatOther(getOtherField('compensationFees2')) }}</span>}
        </div>

        <div class="consultant-label">Other Fees</div>
        <div class="consultant-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="otherFees1" class="ht-input">
          @if (otherMeasurement && isDifferent(form.get('otherFees1')?.value, getOtherField('otherFees1'))) {<span class="ht-other">{{ formatOther(getOtherField('otherFees1')) }}</span>}
        </div>
        <div class="consultant-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="otherFees2" class="ht-input">
          @if (otherMeasurement && isDifferent(form.get('otherFees2')?.value, getOtherField('otherFees2'))) {<span class="ht-other">{{ formatOther(getOtherField('otherFees2')) }}</span>}
        </div>

        <div class="consultant-label">Total Fees</div>
        <div class="consultant-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="totalFees1" class="ht-input" [class.auto-fill-flash]="totalFees1AutoFilled">
          @if (otherMeasurement && isDifferent(form.get('totalFees1')?.value, getOtherField('totalFees1'))) {<span class="ht-other">{{ formatOther(getOtherField('totalFees1')) }}</span>}
        </div>
        <div class="consultant-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="totalFees2" class="ht-input" [class.auto-fill-flash]="totalFees2AutoFilled">
          @if (otherMeasurement && isDifferent(form.get('totalFees2')?.value, getOtherField('totalFees2'))) {<span class="ht-other">{{ formatOther(getOtherField('totalFees2')) }}</span>}
        </div>
      </div>

      @if (showKeywords) {
        <div class="keywords-inline" formGroupName="keywords">
          <div class="keywords-header">
            <span>Keywords</span>
          </div>
          <div class="keywords-fields">
            <div class="keywords-column">
              <app-keyword-input name="compensationConsultantOne" label="Compensation Consultant 1" />
            </div>
            <div class="keywords-column">
              <app-keyword-input name="compensationConsultantTwo" label="Compensation Consultant 2" />
            </div>
          </div>
        </div>
      }

      <!-- CEO Pay Ratio -->
      <h3 class="section-title" style="margin-top: 12px">CEO Pay Ratio</h3>
      <div class="ceo-pay-grid">
        <div class="cpr-label">Media Employee</div>
        <div class="cpr-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="ceoPayRatioMediaEmployee" class="ht-input">
          @if (otherMeasurement && isDifferent(form.get('ceoPayRatioMediaEmployee')?.value, getOtherField('ceoPayRatioMediaEmployee'))) {<span class="ht-other">{{ formatOther(getOtherField('ceoPayRatioMediaEmployee')) }}</span>}
        </div>
        <div class="cpr-label">Ratio</div>
        <div class="cpr-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="ceoPayRatioRatio" class="ht-input">
          @if (otherMeasurement && isDifferent(form.get('ceoPayRatioRatio')?.value, getOtherField('ceoPayRatioRatio'))) {<span class="ht-other">{{ formatOther(getOtherField('ceoPayRatioRatio')) }}</span>}
        </div>
        <div class="cpr-label">Number of Employees</div>
        <div class="cpr-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="ceoPayRatioNumberOfEmployees" class="ht-input">
          @if (otherMeasurement && isDifferent(form.get('ceoPayRatioNumberOfEmployees')?.value, getOtherField('ceoPayRatioNumberOfEmployees'))) {<span class="ht-other">{{ formatOther(getOtherField('ceoPayRatioNumberOfEmployees')) }}</span>}
        </div>
      </div>
    </div>

  </div>

  <!-- Comments -->
  <section class="section-container nrg-border-radius-second-level comments-section">
    <div class="section-header">
      <span>Comments</span>
    </div>
    <div class="section-content">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments2" rows="3"></textarea>
      </mat-form-field>
    </div>
  </section>

</div>
